import { makeStyles } from '@material-ui/core/styles';
import { getChartColor } from '../../../utilities/ColorUtilities';

export const useStyles = makeStyles((theme) => ({
    chartContainer: {
        position: 'relative',
    },
    chart: {
        ...(theme.palette.type === 'dark'
            ? {
                  '& .highcharts-axis-title': {
                      color: '#C5C5C5 !important',
                      fill: '#C5C5C5 !important',
                  },
              }
            : {}),
        '& .highcharts-data-label': {
            textAlign: 'center',
        },
        '& .highcharts-datalabel-callout': {
            margin: 'auto',
            borderColor: getChartColor('xAxisTicks', theme.palette.type),
            borderWidth: '1px',
            borderStyle: 'solid',
            padding: '2px',
            paddingRight: '5px',
            backgroundColor: getChartColor('dataLabelBackground', theme.palette.type),
        },
        '& .material-icons': {
            verticalAlign: 'middle',
            fontSize: 20,
            maxWidth: 20,
            overflow: 'hidden',
        },
    },
}));
